import i18n from 'i18n';
import React, { useState } from 'react';
import { features } from 'configs';
import { PropTypes } from 'prop-types';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { cpfFormat, formatName } from 'utils/AuxiliarFunctions';
import {
  formatISO2DisplayDateString,
  formatISO2DisplayTimeString,
} from 'utils/dateFunctions';
import { PaginationComponent } from 'pages/SearchPage/components/Pagination';
import { useEHRContext } from 'contexts/EHRContext';
import { useHistory } from 'react-router-dom';

import { useSharePageUtils } from 'pages/SharePage/utils/useSharePageUtils';

export function ReceivedConsentsTab({ data, searchFilter }) {
  const [isOpen, setIsOpen] = useState(false);
  const [itensPerPage, setItensPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const pages = Math.ceil(data.length / itensPerPage);
  const startIndex = currentPage * itensPerPage;
  const endIndex = startIndex + itensPerPage;
  const currentItems = filterToDisplayList(data) || [];

  const { setPatient } = useEHRContext();
  const history = useHistory();
  const { checkIfPastDate } = useSharePageUtils();

  function filterToDisplayList(listToFilter) {
    if (listToFilter) {
      return listToFilter
        ?.slice(startIndex, endIndex)
        ?.filter(
          (filter) =>
            filter?.pat_name
              ?.toUpperCase()
              ?.includes(searchFilter.toUpperCase()) ||
            filter?.pat_id?.includes(searchFilter) ||
            filter?.date?.includes(searchFilter),
        );
    } else {
      return [];
    }
  }

  function validateAccess(vigency, id) {
    if (!checkIfPastDate(vigency)) {
      setPatient({
        resourceId: id,
      });
      history.push('/registros');
    }
  }

  return (
    <div>
      <button
        className="dropdownTitleButton"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? (
          <FaAngleUp className="tabArea-angleIcon" />
        ) : (
          <FaAngleDown className="tabArea-angleIcon" />
        )}
        <p className="dropdownTitle">Recebidos</p>
        <strong className="radius">
          {searchFilter === '' ? data.length : currentItems.length}
        </strong>
      </button>
      {isOpen ? (
        <>
          <div className="consents-shareTable">
            <div className="consents-shareTableHeader">
              <div className="first">
                <p> CPF </p>
              </div>
              <div className="nome">
                <p> Nome </p>
              </div>
              <div className="date">
                <p> Data </p>
              </div>
              <div className="time">
                <p> Hora </p>
              </div>
              <div className="action-validade">
                <p> Validade </p>
              </div>
            </div>

            {/* {data
                  ? (
                    <>
                      {currentItems.map(((consent, index) => (
                        <div role="list">
                            <div className="first"><p>{cpfFormat(consent.pat_id)}</p></div>
                            <div className="nome"><p>{formatName(consent.pat_name)}</p></div>
                            <div className="date"><p>{formatISO2DisplayDateString(consent.horario, i18n.language || 'Não Encontrado')}</p></div>
                            <div className="time">
                              <p>
                                {formatISO2DisplayTimeString(consent.horario, i18n.language || 'Não Encontrado').slice(0, -3)}
                              </p>
                            </div>
                          </div>
                        </div>
                      )))}
                      <hr />
                    </>
                  )
                  : <></>} */}
            {/* <PaginationComponent items={currentItems.length} totalItens={data.length} setItensPerPage={setItensPerPage} setCurrentPage={setCurrentPage} pages={pages} currentPage={currentPage} />

              </div>
            </div> */}

            {data ? (
              <>
                {currentItems?.map((consent, index) => (
                  <div role="list">
                    <div
                      key={`receivedConsent-${index}`}
                      className="consents-shareTableBody"
                      role="button"
                      tabIndex="0"
                      onClick={() =>
                        validateAccess(consent.dateVigency, consent.pat_id)
                      }
                    >
                      <div
                        className={
                          checkIfPastDate(consent.dateVigency)
                            ? 'textConsentExpired first'
                            : 'first'
                        }
                      >
                        <p>{cpfFormat(consent.pat_id)}</p>
                      </div>
                      <div
                        className={
                          checkIfPastDate(consent.dateVigency)
                            ? 'textConsentExpired nome'
                            : 'nome'
                        }
                      >
                        <p>{formatName(consent.pat_name)}</p>
                      </div>
                      <div
                        className={
                          checkIfPastDate(consent.dateVigency)
                            ? 'textConsentExpired date'
                            : 'date'
                        }
                      >
                        <p>
                          {formatISO2DisplayDateString(
                            consent.horario,
                            i18n.language || 'Não Encontrado',
                          )}
                        </p>
                      </div>
                      <div
                        className={
                          checkIfPastDate(consent.dateVigency)
                            ? 'textConsentExpired time'
                            : 'time'
                        }
                      >
                        <p>
                          {formatISO2DisplayTimeString(
                            consent.horario,
                            i18n.language || 'Não Encontrado',
                          ).slice(0, -3)}
                        </p>
                      </div>
                      <div
                        className={
                          checkIfPastDate(consent.dateVigency)
                            ? 'textConsentExpired vigency'
                            : 'vigency'
                        }
                      >
                        <p>
                          {consent.dateVigency === null ||
                          consent.dateVigency === undefined
                            ? 'Até revogação manual'
                            : formatISO2DisplayDateString(
                                consent.dateVigency,
                                i18n.language || 'Não Encontrado',
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <></>
            )}
            <PaginationComponent
              items={itensPerPage}
              totalItens={data.length}
              setItensPerPage={setItensPerPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              currentPage={currentPage}
            />
          </div>
        </>
      ) : (
        <>{features.granted && <hr className="hr" />}</>
      )}
    </div>
  );
}
ReceivedConsentsTab.propTypes = {
  data: PropTypes.element.isRequired,
  searchFilter: PropTypes.element.isRequired,
};
